import { type GetSortingColId } from '@autone/ui';
import { createPaginatedInfiniteQueryHook } from '@autone/utils';

import {
  type GetAssortmentSkuLocationsSortOption,
  useGetPaginatedAssortmentSkuLocationsInfiniteQuery,
} from '../../../redux/assortment';

import { type SkuLocationsTableColumnId } from './SkuLocationsTable.types';

export type AssortmentSkuLocationsSortKeys =
  GetAssortmentSkuLocationsSortOption;

export type AssortmentSkuLocationsSortableFieldIds =
  GetSortingColId<AssortmentSkuLocationsSortKeys>;

const sortableFieldToColumnIdMap: Record<
  AssortmentSkuLocationsSortableFieldIds,
  SkuLocationsTableColumnId
> = {
  location_id: 'location',
};

export const sortableColumnToFieldIdMap = Object.fromEntries(
  Object.entries(sortableFieldToColumnIdMap).map(([k, v]) => [v, k]),
) as Record<SkuLocationsTableColumnId, AssortmentSkuLocationsSortableFieldIds>;

export const usePaginatedAssortmentSkuLocationsQuery =
  createPaginatedInfiniteQueryHook(
    useGetPaginatedAssortmentSkuLocationsInfiniteQuery,
  );
